/**
 * ИИ-ручки текста, на которых у гостевой сессии действует лимит бесплатных
 * запросов к LLM. Бэк на исчерпании лимита отдаёт 429.
 */
const GUEST_LLM_LIMIT_PATHS = [
    "/texts/create",
    "/texts/from-custom-text",
    "/edit-with-ai",
];
/**
 * true ⇢ это ответ 429 с ИИ-ручки текста, т.е. у гостя кончился лимит
 * бесплатных генераций/редактирований.
 */
export function isGuestLlmLimitError(error) {
    const err = error;
    if (err?.response?.status !== 429) {
        return false;
    }
    const url = err.config?.url ?? "";
    return GUEST_LLM_LIMIT_PATHS.some((path) => url.includes(path));
}
/** Локализованный текст «лимит бесплатных запросов исчерпан». */
export function guestLlmLimitMessage(language) {
    return language === "ru"
        ? "Лимит бесплатных запросов исчерпан"
        : "You've reached the free request limit";
}
/**
 * Приводит `detail` (FastAPI/Pydantic) к строке: строка → как есть; массив
 * ошибок валидации [{ msg, loc, ... }] → склейка msg; объект → msg/JSON.
 * Без этого объект/массив попадал в React-узел и ронял рендер (ошибка #31).
 */
function detailToString(detail) {
    if (!detail) {
        return "";
    }
    if (typeof detail === "string") {
        return detail;
    }
    if (Array.isArray(detail)) {
        return detail
            .map((item) => {
            if (typeof item === "string")
                return item;
            if (item && typeof item === "object" && "msg" in item) {
                return String(item.msg ?? "");
            }
            return "";
        })
            .filter(Boolean)
            .join("; ");
    }
    if (typeof detail === "object" && "msg" in detail) {
        return String(detail.msg ?? "");
    }
    return "";
}
/**
 * Сообщение об ошибке для тостов на ИИ-ручках текста: для гостевого лимита
 * (429) — про исчерпанный лимит, иначе обычный detail/message/fallback.
 * Всегда возвращает СТРОКУ (см. detailToString).
 */
export function resolveTextActionErrorMessage(error, language, fallbackRu, fallbackEn) {
    if (isGuestLlmLimitError(error)) {
        return guestLlmLimitMessage(language);
    }
    const detail = detailToString(error?.response?.data?.detail);
    const message = typeof error?.response?.data?.message === "string"
        ? error.response.data.message
        : "";
    const errMessage = typeof error?.message === "string" ? error.message : "";
    return (detail ||
        message ||
        errMessage ||
        (language === "ru" ? fallbackRu : fallbackEn));
}
